import { Button, Table,Spin, Modal, Form, Input, InputNumber, Select} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import {CloseOutlined, FileExcelOutlined, SaveOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import * as XLSX from 'xlsx';
import {AUTH_URL} from '../constants';
import { TfiReload } from 'react-icons/tfi';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import dayjs, { Dayjs } from 'dayjs';
import {IBranch, IExpense} from '../factory/interfaces'
import { IoEnterSharp } from "react-icons/io5"
import TextArea from 'antd/es/input/TextArea';
import { notify, notify_success, toastStyle } from '../pages/LoginPage';
import { IoMdArrowDropright } from 'react-icons/io';
import { selectUserDetails } from '../features/auth/authSlice';
import { useSelector } from 'react-redux';



const { RangePicker } = DatePicker


const Expensestable = () => {
    const dispatch = useDispatch()

    const [dateRange, setDateRange]= useState<string[]>(['2024-03-17', '2024-05-20'])
    const [showExpenseForm, setShowExpenseForm] = useState(false)
    const [expenseData, setExpenseData] = useState<IExpense>()
    const [addingExpense, setAddingExpense] = useState(false)
    const [reloadComponent, setReloadComponent] = useState(false)
    const [expenses, setExpenses] = useState<IExpense[]>()
    const [branches, setBranches]= useState<IBranch[]>()
    const [selectedBranch, setSelectedBranch]= useState<string>()

    const [form] = Form.useForm()
  

     //Redux states
    const userDetails = useSelector(selectUserDetails)
    const isAdmin = userDetails?.role === 'admin'
    const metadata = useSelector((state: any) => state.metadata)

    //Functions

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Date',
    dataIndex: 'date_of_creation',
    key: 'date_of_creation',
  },
  {
    title: 'Agent',
    dataIndex: 'client',
    key: 'agent',
  },
  {
    title: 'Narration',
    dataIndex: 'narration',
    key: 'narration',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
  },

];

  const handleClose = ()=>{
    setShowExpenseForm(false)
    form.resetFields()
    }
  const showForm = ()=>setShowExpenseForm(true)


    const getExpenses = async()=>{
      const response = await axios.post(`${AUTH_URL}/expenses`, {branch: selectedBranch}, {withCredentials: true})
      if(response.data.success){
        setExpenses(response.data.expenses)
      }

    }

    const registerExpense = async()=>{
      setAddingExpense(true)
      const expenseData = {
        amount: form.getFieldValue('amount'),
        branch: form.getFieldValue('branch'),
        narration: form.getFieldValue('narration')
      }
      const response = await axios.post(`${AUTH_URL}/expenses/register`, expenseData, {withCredentials: true})
      setAddingExpense(false)
      if(response.data.success){
        notify_success(`${response.data.message}`, toastStyle)
        form.resetFields()
        handleClose()
        setReloadComponent(true)
      }else{
        notify(`${response.data.message}`, toastStyle)

      }
    }

 useEffect(() => {
    if (metadata?.data?.success) {
      setBranches(metadata.data.meta_data.branches)
    }
  }, [metadata])

  useEffect(()=>{
    if(reloadComponent){
        getExpenses()
        setReloadComponent(false)
    }
}, [reloadComponent])

  useEffect(()=>{
    getExpenses()

  }, [dispatch, dateRange, selectedBranch])

  return (
    <>
    {expenses? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Expenses</h4>

         </Col>
    

         <Col className='text-end py-2 d-flex justify-content-end'>
            {
              isAdmin &&
              <Select
              allowClear
              placeholder="Select branch name"
              style={{ width: '' }}
              options={branches?.map((branch) => ({
                value: branch._id,
                label: branch.name,
              }))}
              onChange={(value: string) =>
                  setSelectedBranch(value)
                }
              />}
            <Button type='primary' onClick={showForm} className='rounded-0 mx-1'> <IoEnterSharp style={{marginRight: '5px'}} /> <span>New Expense</span></Button>
            <Button  className='rounded-0' type="dashed"> <TfiReload/> <span className='mx-1'>Reload</span></Button>
         </Col>
            
        </Row>
    
     {
      expenses &&
      <Table pagination={false} className='rounded-0 transactions-table' id='dlms-expenses-data' bordered dataSource={expenses} columns={columns} 
       />
     }
     
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading expenses..." size="large">
        <div className="content" />
      </Spin>

    }
   
      <Modal
      width={600} open={showExpenseForm} onCancel={handleClose}
         title={`REGISTER EXPENSE`}
         centered
         footer={[
                     [

                      ]
                ]}
      >
      <Form
          layout="vertical"
          form={form}
          onFinish={registerExpense}

          >
          <Form.Item 
          label="Amount"
          name="amount"
          rules={[{ required: true, message: "Expense amount is required" }]}
          tooltip='Do not include spaces or commas'
          >
              <InputNumber placeholder='Enter amount spent' min={1} style={{width: '100%'}} className='rounded-0'
                />
          </Form.Item>
          {
            isAdmin &&
              <Form.Item 
              label="Spending branch"
              name="branch"
              rules={[{ required: isAdmin, message: "Spending branch is required" }]}
              tooltip='Select the branch to spend the funds'
              >
                <Select
                  allowClear
                  placeholder="Select branch"
                  style={{ width: '100%' }}
                  options={branches?.map((branch) => ({
                              value: branch._id,
                              label: branch.name,
                            }))}
                    ></Select>
              </Form.Item>
          }
          <Form.Item 
            label='Narration/Description'
            name='narration'
            rules={[{ required: true, message: "Expense narration is required" }]}
            tooltip='Provide a description of what the money was spent on'

          >
          <TextArea
            placeholder="Describe the expense here"
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
          </Form.Item>
          <Row className='d-flex gap-4' style={{marginTop: '40px'}}>
          <Col className='d-flex'>
          <Button loading={addingExpense} htmlType="submit" type='primary' className='rounded-0 text-uppercase small' key="edit_user">
              <span><SaveOutlined style={{marginRight: '5px'}} /></span>
              
              {
              addingExpense ?
              'Registering Expense...'
              :
              'Register Expense'
              
              }
          </Button>
          <Button  className='rounded-0 small text-uppercase mx-3' key="cancel" onClick={handleClose}>
            <CloseOutlined />   Cancel
          </Button>
          
          </Col>
          </Row>
          
        </Form>
      </Modal>
    </>
  )
}

export default Expensestable